import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {ProjectDriveContainerModel} from "../../../../../../../models/aggregates/alg/cc/link";
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";

@Injectable({providedIn: 'root'})
export class ProjectDriveService extends BaseApiTemplateService<ProjectDriveContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'project-drive-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'project-drive-links';
    this.httpClient = http;
  }
}
